import {
  updateCurrentContext
} from "./chunk-FCWOJULD.mjs";
import {
  timestamp
} from "./chunk-QBXWAUJA.mjs";
import {
  defaultSessionExpiration
} from "./chunk-ADSPBXJF.mjs";

// src/utils/context/get-session-id/get-session-id.ts
var storageKey = "__yvse";
async function getSessionId({ updateContext } = {}) {
  const { unix: now } = timestamp();
  const sessionExpiration = window.yvaDatastore?.config.sessionExpiration ?? defaultSessionExpiration;
  let existingSession = null;
  try {
    const sessionFromStorage = window.sessionStorage.getItem(storageKey);
    if (sessionFromStorage) {
      const parsedSession = JSON.parse(sessionFromStorage);
      if (parsedSession && typeof parsedSession === "object" && parsedSession.created && parsedSession.expires && parsedSession.id) {
        existingSession = parsedSession;
      }
    }
  } catch (error) {
    if (window.yvaDatastore?.config.debug) {
      console.error("Error parsing stored session");
      console.dir(error, { depth: null });
    }
  }
  if (!existingSession || existingSession.expires <= now) {
    let newSessionId = self.crypto.randomUUID();
    if (window.yvaDatastore?.config.debug) {
      console.log("Session is stale. Creating new session", newSessionId, " | Expires at", now + sessionExpiration);
    }
    window.sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        created: now,
        expires: now + sessionExpiration,
        id: newSessionId
      })
    );
    if (updateContext) {
      await updateCurrentContext({ session_id: newSessionId });
    }
    return newSessionId;
  } else {
    if (window.yvaDatastore?.config.debug) {
      console.log("Refreshing session. Extending session expiration to", now + sessionExpiration);
    }
    window.sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        created: existingSession.created,
        expires: now + sessionExpiration,
        id: existingSession.id
      })
    );
    return existingSession.id;
  }
}

export {
  storageKey,
  getSessionId
};
